import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import axios from "axios"
import Cookies from 'js-cookie'
import { handleAlert } from '../functions/handleAlert'

export const getFormsList = createAsyncThunk("formsList/getFormsList",async(args)=>{
    const token = Cookies.get(`${process.env.REACT_APP_TOKEN_NAME}`) 
    let res;
    if(args){
      const {search,status,date} = args
      res = await axios.get(`${process.env.REACT_APP_SERVER_URL}/dashboard/listOrders?limit=10&page=0&search=${search || ""}&status=${status || ""}&date=${date||""}`,{
        headers:{
          Authorization:`Bearer ${token}`
        }
      })
    }else{
      res = await axios.get(`${process.env.REACT_APP_SERVER_URL}/order?limit=10&page=0&search=&category=`,{
        headers:{
          Authorization:`Bearer ${token}`
        }
      })
    }
    // console.log(res.data)
    return res.data
})

const initialState = {
  formsList:null,
  isLoading:true
}

export const formsListSlice = createSlice({
  name: 'formsList',
  initialState,
  reducers: {
  },
  extraReducers:(builder)=>{
    builder.addCase(getFormsList.pending, (state) => {
      state.isLoading = true
    })
    builder.addCase(getFormsList.fulfilled, (state, { payload }) => {
      state.formsList = payload
      state.isLoading = false
    })
    builder.addCase(getFormsList.rejected, (_, action) => {
      if (action.payload) {
        handleAlert(action.payload.errorMessage , "error") 
      } else {
        handleAlert(action.error.message, "error") 
      }
    })
  }
})


export default formsListSlice.reducer